// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CurlImporter_variablesSection__ixCsd {
  margin-top: 1rem;
  padding: 0.75rem;
  background: #f5f8ff;
  border: 1px solid #d0d9f0;
  border-radius: 6px;
}
.CurlImporter_variablesTitle__-o9j4 {
  margin: 0 0 0.25rem;
}
.CurlImporter_variablesHint__opLD- {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.75rem;
}
.CurlImporter_variableRow__FpYvb {
  margin-bottom: 0.75rem;
}
.CurlImporter_variableInfo__fYiSl {
  display: flex;
  gap: 1rem;
  font-size: 0.9rem;
}
.CurlImporter_variableControls__D7ODu {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.3rem;
}
.CurlImporter_variableNameInput__3QENz {
  width: 160px;
  padding: 0.3rem;
}
.CurlImporter_hardcodeLabel__rJ1hk {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.85rem;
}
.CurlImporter_urlPreview__UVANi {
  margin-top: 0.75rem;
  font-size: 0.9rem;
}
.CurlImporter_previewUrl__mMsyX {
  background: #eef;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  word-break: break-all;
}

.CurlImporter_sampleHeader__\\+\\+WB4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.CurlImporter_addButton__PsyUy {
  padding: 8px 16px;
  background: #f1f3f4;
  color: #328bff;
  border: 2px solid #bbd8ff;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.813rem;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  gap: 5px;
}
.CurlImporter_addButton__PsyUy:hover {
  background: rgb(187, 214, 255);
  color: #202124;
}
.CurlImporter_addButton__PsyUy:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.CurlImporter_sampleRow__yuPpG {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;
  background: #fafafa;
}

.CurlImporter_sampleStatusGroup__3xV2j {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.CurlImporter_statusLabel__r3sL2 {
  font-size: 13px;
  font-weight: 500;
}

.CurlImporter_statusSelect__3WZ6J {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  background: white;
}

.CurlImporter_statusCustomInput__RO-n1 {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  width: 100px;
}

.CurlImporter_removeButton__Hxvnu {
  background: transparent;
  border: none;
  color: #f44336;
  cursor: pointer;
  padding: 4px;
}
.CurlImporter_removeButton__Hxvnu:hover:not(:disabled) {
  color: #d32f2f;
}
.CurlImporter_removeButton__Hxvnu:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.CurlImporter_sampleTextarea__aws87 {
  margin-top: 4px;
  min-height: 60px;
}

.CurlImporter_sampleLabel__J5\\+gF {
  font-weight: 600;
}

.CurlImporter_statusCodeGroup__Zjsw9 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}
.CurlImporter_statusLabel__r3sL2 {
  font-size: 13px;
  font-weight: 500;
}
.CurlImporter_statusInput__pvi5y {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 80px;
  font-size: 13px;
}
.CurlImporter_helperText__yse4k {
  display: block;
  color: #666;
  font-size: 14px;
  margin-top: 4px;
}

.CurlImporter_container__bfB9N {
  margin: 20px 0px;
  padding: 20px;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
  border-radius: 12px;
  border: 1px solid #b3c6ff;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.CurlImporter_container__bfB9N:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #8ab3ff;
}

.CurlImporter_title__5wn76 {
  font-weight: 600;
  margin-bottom: 12px;
  color: #1a73e8;
  font-size: 0.875rem;
  letter-spacing: 0.3px;
  width: 100%;
  border-radius: 8px;
}

.CurlImporter_textarea__hWc4s {
  width: 100%;
  font-family: "Courier New", monospace;
  font-size: 0.75rem;
  padding: 10px 12px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: #ffffff;
  resize: vertical;
}

.CurlImporter_textarea__hWc4s:focus {
  outline: none;
  border-color: #1a73e8;
  background: white;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.CurlImporter_textarea__hWc4s:disabled {
  background: #f8f9fa;
  color: #5f6368;
  cursor: not-allowed;
  opacity: 0.7;
}
.CurlImporter_textarea__hWc4s::placeholder {
  color: #7b7d80;
  font-weight: 300;
  opacity: 0.8;
}
.CurlImporter_sampleSection__icHt3 {
  margin-top: 12px;
}

.CurlImporter_sampleLabel__J5\\+gF {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  color: #202124;
  font-size: 0.813rem;
}

.CurlImporter_buttonGroup__x\\+6wO {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* ==================== IMPORT BUTTON STYLES ==================== */
.CurlImporter_importButton__vYfmt {
  background: var(--editBtn, #a370ce);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  font-size: 0.813rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  position: relative;
  overflow: hidden;
  animation:
    CurlImporter_breathe__OTb\\+h 2s ease-in-out infinite,
    CurlImporter_pulseGlow__TUKm3 2s ease-in-out infinite;
}

/* PULSE ANIMATION - FIXED AND IMPROVED */
@keyframes CurlImporter_pulse__tsTca {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
    box-shadow: 0 6px 28px rgba(163, 112, 206, 0.5);
  }
  50% {
    transform: scale(0.95);
    box-shadow: 0 2px 12px rgba(163, 112, 206, 0.3);
  }
  75% {
    transform: scale(1.05);
    box-shadow: 0 6px 24px rgba(163, 112, 206, 0.4);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  }
}

/* FIX: Pulse now properly applied with longer duration */
.CurlImporter_importButton__vYfmt:active:not(:disabled) {
  /* animation: pulse 0.7s cubic-bezier(0.4, 0, 0.2, 1) forwards; */
  animation:
    CurlImporter_breathe__OTb\\+h 2s ease-in-out infinite,
    CurlImporter_pulseGlow__TUKm3 2s ease-in-out infinite;
}

/* Hover effect with smooth transition instead of animation */
.CurlImporter_importButton__vYfmt:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 32px rgba(163, 112, 206, 0.4);
}

/* Shine effect on hover */
.CurlImporter_importButton__vYfmt::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.CurlImporter_importButton__vYfmt:hover:not(:disabled)::before {
  left: 100%;
}

/* Disabled state */
.CurlImporter_importButton__vYfmt:disabled {
  background: #dadce0;
  cursor: not-allowed;
  opacity: 0.6;
  color: #5f6368;
  transform: none !important;
  box-shadow: none !important;
}

/* Focus visible for accessibility */
.CurlImporter_importButton__vYfmt:focus-visible {
  outline: 2px solid #1a73e8;
  outline-offset: 2px;
}

/* ==================== BREATHING ANIMATION FOR IMPORT READY STATE ==================== */
@keyframes CurlImporter_breathe__OTb\\+h {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 0 6px 24px rgba(163, 112, 206, 0.45);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  }
}

@keyframes CurlImporter_pulseGlow__TUKm3 {
  0% {
    box-shadow: 0 0 0 0 rgba(163, 112, 206, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(163, 112, 206, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(163, 112, 206, 0);
  }
}

.CurlImporter_importButton__vYfmt:not(:disabled).CurlImporter_isImportReady__Hxy5X {
  animation:
    CurlImporter_breathe__OTb\\+h 2s ease-in-out infinite,
    CurlImporter_pulseGlow__TUKm3 2s ease-in-out infinite;
}
/* ==================== END IMPORT BUTTON STYLES ==================== */

.CurlImporter_errorMessage__u9rdk {
  color: var(--deleteBtn, #d32f2f);
  font-size: 0.813rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.CurlImporter_errorMessage__u9rdk::before {
  content: "⚠️";
  font-size: 0.875rem;
}

.CurlImporter_warningMessage__wVCSZ {
  color: var(--warning, #f57c00);
  font-size: 0.813rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.CurlImporter_warningMessage__wVCSZ::before {
  content: "⚠️";
  font-size: 0.875rem;
}

.CurlImporter_preview__OkLZr {
  margin-top: 12px;
  font-size: 0.688rem;
  background: var(--white-color, #ffffff);
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #dadce0;
  overflow-x: auto;
  font-family: "Courier New", monospace;
  color: #202124;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
  animation: CurlImporter_fadeIn__F0TPm 0.3s ease-out;
}

/* Scrollbar styling */
.CurlImporter_preview__OkLZr::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.CurlImporter_preview__OkLZr::-webkit-scrollbar-track {
  background: #f1f3f4;
  border-radius: 4px;
}

.CurlImporter_preview__OkLZr::-webkit-scrollbar-thumb {
  background: #dadce0;
  border-radius: 4px;
}

.CurlImporter_preview__OkLZr::-webkit-scrollbar-thumb:hover {
  background: #bdc1c6;
}

/* Preview fade-in animation */
@keyframes CurlImporter_fadeIn__F0TPm {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .CurlImporter_container__bfB9N {
    padding: 12px;
  }

  .CurlImporter_title__5wn76 {
    font-size: 0.813rem;
  }

  .CurlImporter_textarea__hWc4s {
    font-size: 0.688rem;
    padding: 8px 10px;
  }

  .CurlImporter_importButton__vYfmt {
    width: 100%;
    text-align: center;
    justify-content: center;
  }

  .CurlImporter_buttonGroup__x\\+6wO {
    flex-direction: column;
    align-items: stretch;
    margin-top: 20px;
  }

  .CurlImporter_errorMessage__u9rdk,
  .CurlImporter_warningMessage__wVCSZ {
    text-align: center;
    justify-content: center;
  }

  .CurlImporter_preview__OkLZr {
    font-size: 0.625rem;
    padding: 10px;
    max-height: 250px;
  }
  .CurlImporter_sampleHeader__\\+\\+WB4{
    flex-direction: column;
    margin: 20px auto;
  }
  .CurlImporter_addButton__PsyUy{
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
  .CurlImporter_helperText__yse4k{
    font-size: 12px;
  }

  
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/CurlImporter.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,QAAQ;AACV;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB;;yDAEmC;AACrC;;AAEA,yCAAyC;AACzC;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,+CAA+C;EACjD;EACA;IACE,sBAAsB;IACtB,+CAA+C;EACjD;EACA;IACE,sBAAsB;IACtB,+CAA+C;EACjD;EACA;IACE,mBAAmB;IACnB,gDAAgD;EAClD;AACF;;AAEA,yDAAyD;AACzD;EACE,iEAAiE;EACjE;;yDAEmC;AACrC;;AAEA,6DAA6D;AAC7D;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,yFAAyF;AACzF;EACE;IACE,mBAAmB;IACnB,gDAAgD;EAClD;EACA;IACE,sBAAsB;IACtB,gDAAgD;EAClD;EACA;IACE,mBAAmB;IACnB,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;;yDAEmC;AACrC;AACA,uEAAuE;;AAEvE;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,mDAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;;;AAGF","sourcesContent":[".variablesSection {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background: #f5f8ff;\n  border: 1px solid #d0d9f0;\n  border-radius: 6px;\n}\n.variablesTitle {\n  margin: 0 0 0.25rem;\n}\n.variablesHint {\n  font-size: 0.85rem;\n  color: #666;\n  margin-bottom: 0.75rem;\n}\n.variableRow {\n  margin-bottom: 0.75rem;\n}\n.variableInfo {\n  display: flex;\n  gap: 1rem;\n  font-size: 0.9rem;\n}\n.variableControls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 0.3rem;\n}\n.variableNameInput {\n  width: 160px;\n  padding: 0.3rem;\n}\n.hardcodeLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.85rem;\n}\n.urlPreview {\n  margin-top: 0.75rem;\n  font-size: 0.9rem;\n}\n.previewUrl {\n  background: #eef;\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  word-break: break-all;\n}\n\n.sampleHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.addButton {\n  padding: 8px 16px;\n  background: #f1f3f4;\n  color: #328bff;\n  border: 2px solid #bbd8ff;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.813rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  gap: 5px;\n}\n.addButton:hover {\n  background: rgb(187, 214, 255);\n  color: #202124;\n}\n.addButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.sampleRow {\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 10px;\n  margin-bottom: 10px;\n  background: #fafafa;\n}\n\n.sampleStatusGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.statusLabel {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.statusSelect {\n  padding: 4px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 13px;\n  background: white;\n}\n\n.statusCustomInput {\n  padding: 4px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 13px;\n  width: 100px;\n}\n\n.removeButton {\n  background: transparent;\n  border: none;\n  color: #f44336;\n  cursor: pointer;\n  padding: 4px;\n}\n.removeButton:hover:not(:disabled) {\n  color: #d32f2f;\n}\n.removeButton:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.sampleTextarea {\n  margin-top: 4px;\n  min-height: 60px;\n}\n\n.sampleLabel {\n  font-weight: 600;\n}\n\n.statusCodeGroup {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 8px;\n}\n.statusLabel {\n  font-size: 13px;\n  font-weight: 500;\n}\n.statusInput {\n  padding: 4px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 80px;\n  font-size: 13px;\n}\n.helperText {\n  display: block;\n  color: #666;\n  font-size: 14px;\n  margin-top: 4px;\n}\n\n.container {\n  margin: 20px 0px;\n  padding: 20px;\n  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);\n  border-radius: 12px;\n  border: 1px solid #b3c6ff;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.container:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-color: #8ab3ff;\n}\n\n.title {\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #1a73e8;\n  font-size: 0.875rem;\n  letter-spacing: 0.3px;\n  width: 100%;\n  border-radius: 8px;\n}\n\n.textarea {\n  width: 100%;\n  font-family: \"Courier New\", monospace;\n  font-size: 0.75rem;\n  padding: 10px 12px;\n  border: 1px solid #dadce0;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  background: #ffffff;\n  resize: vertical;\n}\n\n.textarea:focus {\n  outline: none;\n  border-color: #1a73e8;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.textarea:disabled {\n  background: #f8f9fa;\n  color: #5f6368;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n.textarea::placeholder {\n  color: #7b7d80;\n  font-weight: 300;\n  opacity: 0.8;\n}\n.sampleSection {\n  margin-top: 12px;\n}\n\n.sampleLabel {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: #202124;\n  font-size: 0.813rem;\n}\n\n.buttonGroup {\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n/* ==================== IMPORT BUTTON STYLES ==================== */\n.importButton {\n  background: var(--editBtn, #a370ce);\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 12px;\n  font-size: 0.813rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  position: relative;\n  overflow: hidden;\n  animation:\n    breathe 2s ease-in-out infinite,\n    pulseGlow 2s ease-in-out infinite;\n}\n\n/* PULSE ANIMATION - FIXED AND IMPROVED */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(1.1);\n    box-shadow: 0 6px 28px rgba(163, 112, 206, 0.5);\n  }\n  50% {\n    transform: scale(0.95);\n    box-shadow: 0 2px 12px rgba(163, 112, 206, 0.3);\n  }\n  75% {\n    transform: scale(1.05);\n    box-shadow: 0 6px 24px rgba(163, 112, 206, 0.4);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  }\n}\n\n/* FIX: Pulse now properly applied with longer duration */\n.importButton:active:not(:disabled) {\n  /* animation: pulse 0.7s cubic-bezier(0.4, 0, 0.2, 1) forwards; */\n  animation:\n    breathe 2s ease-in-out infinite,\n    pulseGlow 2s ease-in-out infinite;\n}\n\n/* Hover effect with smooth transition instead of animation */\n.importButton:hover:not(:disabled) {\n  transform: translateY(-2px) scale(1.02);\n  box-shadow: 0 8px 32px rgba(163, 112, 206, 0.4);\n}\n\n/* Shine effect on hover */\n.importButton::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.importButton:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n/* Disabled state */\n.importButton:disabled {\n  background: #dadce0;\n  cursor: not-allowed;\n  opacity: 0.6;\n  color: #5f6368;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Focus visible for accessibility */\n.importButton:focus-visible {\n  outline: 2px solid #1a73e8;\n  outline-offset: 2px;\n}\n\n/* ==================== BREATHING ANIMATION FOR IMPORT READY STATE ==================== */\n@keyframes breathe {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  }\n  50% {\n    transform: scale(1.03);\n    box-shadow: 0 6px 24px rgba(163, 112, 206, 0.45);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  }\n}\n\n@keyframes pulseGlow {\n  0% {\n    box-shadow: 0 0 0 0 rgba(163, 112, 206, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(163, 112, 206, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(163, 112, 206, 0);\n  }\n}\n\n.importButton:not(:disabled).isImportReady {\n  animation:\n    breathe 2s ease-in-out infinite,\n    pulseGlow 2s ease-in-out infinite;\n}\n/* ==================== END IMPORT BUTTON STYLES ==================== */\n\n.errorMessage {\n  color: var(--deleteBtn, #d32f2f);\n  font-size: 0.813rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.errorMessage::before {\n  content: \"⚠️\";\n  font-size: 0.875rem;\n}\n\n.warningMessage {\n  color: var(--warning, #f57c00);\n  font-size: 0.813rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.warningMessage::before {\n  content: \"⚠️\";\n  font-size: 0.875rem;\n}\n\n.preview {\n  margin-top: 12px;\n  font-size: 0.688rem;\n  background: var(--white-color, #ffffff);\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #dadce0;\n  overflow-x: auto;\n  font-family: \"Courier New\", monospace;\n  color: #202124;\n  max-height: 300px;\n  overflow-y: auto;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Scrollbar styling */\n.preview::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.preview::-webkit-scrollbar-track {\n  background: #f1f3f4;\n  border-radius: 4px;\n}\n\n.preview::-webkit-scrollbar-thumb {\n  background: #dadce0;\n  border-radius: 4px;\n}\n\n.preview::-webkit-scrollbar-thumb:hover {\n  background: #bdc1c6;\n}\n\n/* Preview fade-in animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 12px;\n  }\n\n  .title {\n    font-size: 0.813rem;\n  }\n\n  .textarea {\n    font-size: 0.688rem;\n    padding: 8px 10px;\n  }\n\n  .importButton {\n    width: 100%;\n    text-align: center;\n    justify-content: center;\n  }\n\n  .buttonGroup {\n    flex-direction: column;\n    align-items: stretch;\n    margin-top: 20px;\n  }\n\n  .errorMessage,\n  .warningMessage {\n    text-align: center;\n    justify-content: center;\n  }\n\n  .preview {\n    font-size: 0.625rem;\n    padding: 10px;\n    max-height: 250px;\n  }\n  .sampleHeader{\n    flex-direction: column;\n    margin: 20px auto;\n  }\n  .addButton{\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n  }\n  .helperText{\n    font-size: 12px;\n  }\n\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"variablesSection": `CurlImporter_variablesSection__ixCsd`,
	"variablesTitle": `CurlImporter_variablesTitle__-o9j4`,
	"variablesHint": `CurlImporter_variablesHint__opLD-`,
	"variableRow": `CurlImporter_variableRow__FpYvb`,
	"variableInfo": `CurlImporter_variableInfo__fYiSl`,
	"variableControls": `CurlImporter_variableControls__D7ODu`,
	"variableNameInput": `CurlImporter_variableNameInput__3QENz`,
	"hardcodeLabel": `CurlImporter_hardcodeLabel__rJ1hk`,
	"urlPreview": `CurlImporter_urlPreview__UVANi`,
	"previewUrl": `CurlImporter_previewUrl__mMsyX`,
	"sampleHeader": `CurlImporter_sampleHeader__++WB4`,
	"addButton": `CurlImporter_addButton__PsyUy`,
	"sampleRow": `CurlImporter_sampleRow__yuPpG`,
	"sampleStatusGroup": `CurlImporter_sampleStatusGroup__3xV2j`,
	"statusLabel": `CurlImporter_statusLabel__r3sL2`,
	"statusSelect": `CurlImporter_statusSelect__3WZ6J`,
	"statusCustomInput": `CurlImporter_statusCustomInput__RO-n1`,
	"removeButton": `CurlImporter_removeButton__Hxvnu`,
	"sampleTextarea": `CurlImporter_sampleTextarea__aws87`,
	"sampleLabel": `CurlImporter_sampleLabel__J5+gF`,
	"statusCodeGroup": `CurlImporter_statusCodeGroup__Zjsw9`,
	"statusInput": `CurlImporter_statusInput__pvi5y`,
	"helperText": `CurlImporter_helperText__yse4k`,
	"container": `CurlImporter_container__bfB9N`,
	"title": `CurlImporter_title__5wn76`,
	"textarea": `CurlImporter_textarea__hWc4s`,
	"sampleSection": `CurlImporter_sampleSection__icHt3`,
	"buttonGroup": `CurlImporter_buttonGroup__x+6wO`,
	"importButton": `CurlImporter_importButton__vYfmt`,
	"breathe": `CurlImporter_breathe__OTb+h`,
	"pulseGlow": `CurlImporter_pulseGlow__TUKm3`,
	"isImportReady": `CurlImporter_isImportReady__Hxy5X`,
	"errorMessage": `CurlImporter_errorMessage__u9rdk`,
	"warningMessage": `CurlImporter_warningMessage__wVCSZ`,
	"preview": `CurlImporter_preview__OkLZr`,
	"fadeIn": `CurlImporter_fadeIn__F0TPm`,
	"pulse": `CurlImporter_pulse__tsTca`
};
export default ___CSS_LOADER_EXPORT___;
